import { useQuery } from "react-query";
import { getEmployeesWithTerminatedSupervisors } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetEmployeesWithTerminatedSupervisors = () => {
  return useQuery(
    "GetEmployeesWithTerminatedSupervisors",
    getEmployeesWithTerminatedSupervisors,
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetEmployeesWithTerminatedSupervisors;
